import * as React from 'react';

export const OnHoldIcon = () => {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{'2A1EB2BD-2F2A-4952-A46C-46D7948B14AA@1x'}</title>
      <path
        d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm7 8H9a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V9a1 1 0 00-1-1zm-.5 1.5v13h-13v-13h13zM13 15a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2zm3 0a1 1 0 100 2 1 1 0 000-2z"
        fill="#6D717E"
        fillRule="evenodd"
      />
    </svg>
  );
};
